import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up

@Component({
  selector: 'app-units-dearch',
  templateUrl: './units-dearch.component.html',
  styleUrls: ['./units-dearch.component.css']
})
export class UnitsDearchComponent implements OnInit {
  unCode = '';
  unName = '';
  unEach = '0';
  compCode = '1';
  unitsList: UnitsModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<UnitsDearchComponent>,
              public unitsService: UnitsService,
              public units: UnitsModel,
              @Inject(MAT_DIALOG_DATA)
              public unitSelectedData: UnitsModel) { }

  ngOnInit(): void {
    this.retriveUnitsLookupTop();
  }

  retriveUnitsLookup() {
    this.unitsList = [];
    this.unitsService.getUnitsLookup(this.unCode, this.unName, this.compCode).subscribe((data: UnitsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.unitsList[i] = data[i];
      }
      
    })
  }

  retriveUnitsLookupTop() {
    this.unitsList = [];
    this.unitsService.getUnitsLookupTop(this.compCode).subscribe((data: UnitsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.unitsList[i] = data[i];
      }
      console.log(data);
    })
  }

  SelectUnit(unit: UnitsModel){
    this.unitSelectedData.unCode = unit.unCode
    this.unitSelectedData.unrach = unit.unrach
    this.unitSelectedData.unName = unit.unName
    this.unitSelectedData.unArName = unit.unArName
    this.unitSelectedData.userID = unit.userID
    this.unitSelectedData.modifiedDate = unit.modifiedDate
    this.unitSelectedData.compCode = unit.compCode
    this.submitClicked.emit(this.unitSelectedData);
    this.dialogRef.close();
  }
}
